import { useEffect } from "react"
import { useQuery } from "@tanstack/react-query"
import { API } from "../api/api"
import { useAuth } from "./AuthContext"

type AuthStatusResponse = {
  authenticated: boolean
}

export function useAuthStatus() {
  const { setLoggedIn, setChecking } = useAuth()

  const query = useQuery<AuthStatusResponse>({
    queryKey: ["auth-status"],
    queryFn: async () => {
      const res = await API.get<AuthStatusResponse>("/auth/status")
      return res.data
    },
    retry: false,
  })

  const { data, isError, isFetched } = query

  useEffect(() => {
    if (!isFetched) return

    if (isError) {
      setLoggedIn(false)
      setChecking(false)
      return
    }

    setLoggedIn(data?.authenticated === true)
    setChecking(false)
  }, [isFetched, isError, data, setLoggedIn, setChecking])

  return query
}